module.exports = __webpack_public_path__ + "assets/icon-64.png";